import { render, staticRenderFns } from "./DesignView.vue?vue&type=template&id=5ad1eea0&scoped=true&"
import script from "./DesignView.vue?vue&type=script&lang=ts&"
export * from "./DesignView.vue?vue&type=script&lang=ts&"
import style0 from "./DesignView.vue?vue&type=style&index=0&id=5ad1eea0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad1eea0",
  null
  
)

export default component.exports